export default __webpack_public_path__ + "614283775f913494ec872f8be4d8084d.png";